import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  user
  errMess: Error;
  error: Boolean;
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
  }

  loginSubmit(val){
    this.user = val.value;
    //console.log('User: ', this.user);
    this.authService.logIn(this.user)
      .subscribe(res => {
        if (res) {
         // console.log("Successfully logged in");
          this.router.navigateByUrl("/userdash");
        }
      },
      error => {
        //console.log(error);
        this.errMess = error;
        this.error = true;
      });
      
  }

}
